export function publicDocumentPath(appId: string, type: string): string {
  return `/public/docs/${encodeURIComponent(appId)}/${encodeURIComponent(type)}`;
}

export function isPublicDocumentHash(hash: string): boolean {
  return /^#\/public\/docs\/[^/?#]+\/[a-z_]+(?:[?#].*)?$/.test(hash);
}

export function publicDocumentH5Url(appId: string, type: string, origin = "https://admin.yahshi.cn"): string {
  return `${origin.replace(/\/+$/, "")}/#${publicDocumentPath(appId, type)}`;
}

export function publicAnnouncementListPath(appId: string): string {
  return `/public/announcements/${encodeURIComponent(appId)}`;
}

export function publicAnnouncementPath(appId: string, id: string): string {
  return `${publicAnnouncementListPath(appId)}/${encodeURIComponent(id)}`;
}

export function isPublicAnnouncementHash(hash: string): boolean {
  return /^#\/public\/announcements\/[^/?#]+(?:\/[^/?#]+)?(?:[?#].*)?$/.test(hash);
}

export function isPublicH5Hash(hash: string): boolean {
  return isPublicDocumentHash(hash) || isPublicAnnouncementHash(hash);
}

export function publicAnnouncementH5Url(appId: string, id?: string, origin = "https://admin.yahshi.cn"): string {
  const path = id ? publicAnnouncementPath(appId, id) : publicAnnouncementListPath(appId);
  return `${origin.replace(/\/+$/, "")}/#${path}`;
}
